import { FC } from 'react'
import { ReactComponent as CloseIcon } from 'src/assets/svg/modal-close.svg'
import { ReactComponent as StarIcon } from 'src/assets/svg/ri-star-fill.svg'
import { RatingMismatchReview } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'
import styles from './ratingMismatchModal.module.scss'
import { getPlatformIcon } from '../platformIcons'

interface Props {
  isOpen: boolean
  onClose: () => void
  reviews: RatingMismatchReview[]
}

const fmtDate = (iso: string) => {
  const d = new Date(iso)
  return isNaN(d.getTime())
    ? ''
    : d.toLocaleDateString('en', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
}

export const RatingMismatchModal: FC<Props> = ({
  isOpen,
  onClose,
  reviews,
}) => {
  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div>
            <h2 className={styles.title}>Rating vs Sentiment Mismatch</h2>
            <p className={styles.subtitle}>
              {reviews.length} high-rated review
              {reviews.length === 1 ? '' : 's'} whose written feedback reads
              negative
            </p>
          </div>
          <button className={styles.closeBtn} onClick={onClose} type="button">
            <CloseIcon />
          </button>
        </div>

        <div className={styles.list}>
          {reviews.length === 0 && (
            <p className={styles.empty}>No mismatched reviews.</p>
          )}
          {reviews.map((review, idx) => {
            const Icon = getPlatformIcon(review.platform)
            return (
              <div className={styles.reviewRow} key={idx}>
                <div className={styles.reviewTop}>
                  <span className={styles.platformIcon}>
                    <Icon />
                  </span>
                  <span className={styles.platformName}>
                    {review.providerName}
                  </span>
                  <span className={styles.rating}>
                    <span className={styles.star}>
                      <StarIcon />
                    </span>
                    {review.rating}
                  </span>
                  <span className={styles.date}>{fmtDate(review.date)}</span>
                </div>
                <p className={styles.reviewText}>{review.text}</p>
              </div>
            )
          })}
        </div>

        <div className={styles.footer}>
          <button className={styles.doneBtn} onClick={onClose} type="button">
            Done
          </button>
        </div>
      </div>
    </div>
  )
}
